'use client';

import { c as _c } from "react/compiler-runtime";
import type { StructureModuleDTO } from '@algoacademy/backend/modules/docs/endpoints/queries/get-collection-structure/output.dto';
import { DOCS__PERMISSIONS } from '@algoacademy/backend/modules/docs/permissions';
import { Divider } from '@algoacademy/design-system/web/layouts/Divider';
import { LayoutGroup } from 'framer-motion';
import { useParams } from 'next/navigation';
import { useState } from 'react';
import { useAuth } from '@/app/_auth/useAuth';
import { computeInitialOpenSections } from '@/app/baza/(collection)/_helpers/compute-initial-open-sections';
import { useArticleStatesContext } from '@/app/baza/(collection)/_utils/ArticleStateContext/ArticleStateContext';
import { ArticleButton } from './ArticleButton';
import { ModuleButton } from './ModuleButton';
type ModuleSidebarAccordionProps = {
  collectionSlug: string;
  modules: StructureModuleDTO[];
  canManageCollection: boolean;
  isLoggedIn: boolean;
};
export function ModuleSidebarAccordion(t0) {
  const $ = _c(26);
  const {
    collectionSlug,
    modules,
    canManageCollection,
    isLoggedIn
  } = t0;
  const {
    articleSlug: currentArticleSlug
  } = useParams();
  let t1;
  if ($[0] !== currentArticleSlug || $[1] !== modules) {
    t1 = () => computeInitialOpenSections(modules, currentArticleSlug);
    $[0] = currentArticleSlug;
    $[1] = modules;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [openSections, setOpenSections] = useState(t1);
  const {
    states: articleStates
  } = useArticleStatesContext();
  const {
    user
  } = useAuth();
  let t2;
  if ($[3] !== canManageCollection || $[4] !== user) {
    t2 = canManageCollection && user.hasPermissions([DOCS__PERMISSIONS.KNOWLEDGE_BASE.MANAGE.ASSIGNED]) || user.hasPermissions([DOCS__PERMISSIONS.KNOWLEDGE_BASE.MANAGE.ALL]);
    $[3] = canManageCollection;
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const canManageArticle = t2;
  let T0;
  let t3;
  let t4;
  let t5;
  if ($[6] !== articleStates || $[7] !== canManageArticle || $[8] !== collectionSlug || $[9] !== currentArticleSlug || $[10] !== isLoggedIn || $[11] !== modules || $[12] !== openSections) {
    const visibleModules = modules.filter(_temp);
    const allArticles = visibleModules.flatMap(_temp2);
    let t6;
    if ($[17] !== currentArticleSlug) {
      t6 = article => article.slug === currentArticleSlug;
      $[17] = currentArticleSlug;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    const currentGlobalIdx = allArticles.findIndex(t6);
    T0 = LayoutGroup;
    t5 = "baza-module-sidebar";
    t3 = "w-full space-y-2 lg:w-[250px]";
    t4 = visibleModules.map((module_1, index) => {
      const isCurrentModule = module_1.articles.some(article_0 => article_0.slug === currentArticleSlug);
      return <div key={module_1.id} className="space-y-1"><ModuleButton name={module_1.name} isOpen={openSections.includes(index)} isCurrentModule={isCurrentModule} onClick={() => setOpenSections(prev => prev.includes(index) ? prev.filter(section => section !== index) : [...prev, index])} />{openSections.includes(index) && <ul className="flex flex-col pb-2">{module_1.articles.map(article_1 => {
            const globalIdx = allArticles.findIndex(item => item.slug === article_1.slug);
            return <li key={article_1.id}><ArticleButton article={article_1} collectionSlug={collectionSlug} isLoggedIn={isLoggedIn} canManageArticle={canManageArticle} isCurrent={globalIdx === currentGlobalIdx} status={articleStates[article_1.id]} /></li>;
          })}</ul>}{index < visibleModules.length - 1 && <Divider />}</div>;
    });
    $[6] = articleStates;
    $[7] = canManageArticle;
    $[8] = collectionSlug;
    $[9] = currentArticleSlug;
    $[10] = isLoggedIn;
    $[11] = modules;
    $[12] = openSections;
    $[13] = T0;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    T0 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
  }
  let t6;
  if ($[19] !== t3 || $[20] !== t4) {
    t6 = <main className={t3}>{t4}</main>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== T0 || $[23] !== t5 || $[24] !== t6) {
    t7 = <T0 id={t5}>{t6}</T0>;
    $[22] = T0;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}
function _temp2(module_0) {
  return module_0.articles;
}
function _temp(module) {
  return !module.isDefaultDraftModule;
}